//#region src/api_header.ts
var ApiHeader = /* @__PURE__ */ function(ApiHeader) {
	ApiHeader["ApiVersion"] = "x-md-api-version";
	ApiHeader["BiteServiceName"] = "x-bite-service-name";
	ApiHeader["CustomerToken"] = "x-customer-token";
	ApiHeader["CustomerAppScope"] = "x-customer-app-scope";
	ApiHeader["EloViewCiToken"] = "x-elo-view-ci-token";
	ApiHeader["FlashSessionId"] = "x-flash-session-id";
	ApiHeader["GarconBuildName"] = "x-garcon-build-name";
	ApiHeader["GcnBuildName"] = "x-gcn-build-name";
	ApiHeader["VitrineBuildName"] = "x-vitrine-build-name";
	ApiHeader["KioskBuildName"] = "x-kiosk-build-name";
	ApiHeader["KioskBuildNumber"] = "x-kiosk-build-number";
	ApiHeader["KioskId"] = "x-bite-kiosk-id";
	ApiHeader["KioskIdDeprecated"] = "x-kiosk-id";
	ApiHeader["KioskOs"] = "x-kiosk-os";
	ApiHeader["LocationId"] = "x-bite-location-id";
	ApiHeader["OrderChannel"] = "x-bite-order-channel";
	ApiHeader["OrgId"] = "x-bite-org-id";
	ApiHeader["PublicKey"] = "x-bite-public-key";
	ApiHeader["RefundToken"] = "x-bite-refund-token";
	ApiHeader["ReleaseBuildsCiToken"] = "x-release-builds-ci-token";
	ApiHeader["SiteId"] = "x-bite-site-id";
	return ApiHeader;
}(ApiHeader || {});
//#endregion
export { ApiHeader };

//# sourceMappingURL=api_header.js.map